/**
 * CREW PROBABILITY - Constantes réutilisables pour la probabilité
 */

import { CREW_PROBABILITY, CREW_PROBABILITY_LABELS } from '@/types/crew';

/**
 * Options pour les selects de probabilité
 */
export const PROBABILITY_SELECT_OPTIONS = [
  { value: CREW_PROBABILITY.LOW, label: CREW_PROBABILITY_LABELS[CREW_PROBABILITY.LOW] },
  { value: CREW_PROBABILITY.MEDIUM, label: CREW_PROBABILITY_LABELS[CREW_PROBABILITY.MEDIUM] },
  { value: CREW_PROBABILITY.HIGH, label: CREW_PROBABILITY_LABELS[CREW_PROBABILITY.HIGH] },
];

/**
 * Options pour les filtres de probabilité
 */
export const PROBABILITY_FILTER_OPTIONS = [
  { value: 'low', label: 'Faible' },
  { value: 'medium', label: 'Moyenne' },
  { value: 'high', label: 'Forte' },
];
